export const REDUX_KEY = 'app/Notifications';

export const PUSH = 'app/Notifications/PUSH';
export const DISMISS = 'app/Notifications/DISMISS';



// WEBPACK FOOTER //
// ./app/containers/Notifications/constants.js